module.exports = __webpack_public_path__ + "img/logo-by-traxion.83803ce2.png";